exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-slider-container .vue-slider-dot{z-index:1}.price-slider-container .vue-slider-dot-tooltip-bottom{width:-webkit-max-content;width:-moz-max-content;width:max-content;margin:2px 3px;font-size:13px;left:25% !important}.price-slider-container .vue-slider-dot-tooltip-bottom::after{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid black}\n", ""]);

// exports
